<template>
  <table class="Table">
    <slot />
  </table>
</template>

<script>
export default {
  name: 'TableBase',
};
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

.Table {
  width: 100%;
  table-layout: fixed;
}
</style>
